import { useNavigationType } from '@remix-run/react';
import { useEffect, useRef, useState } from 'react';

/**
 * Determine whether at least one navigation has committed since initial mount.
 * Returns false on first render (including hard refresh/direct entry),
 * then flips to true after the first navigation update and stays true.
 */
export function useHasNavigatedSinceMount(): boolean {
  const navigationType = useNavigationType();
  const isFirstLoadRef = useRef(true);
  const [hasNavigatedSinceMount, setHasNavigatedSinceMount] = useState(false);

  useEffect(() => {
    if (isFirstLoadRef.current) {
      setHasNavigatedSinceMount(false);
      isFirstLoadRef.current = false;
      return;
    }

    setHasNavigatedSinceMount(true);
  }, [navigationType]);

  return hasNavigatedSinceMount;
}
